import React from 'react';
import {NavLink} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import Icon from '../../../icon';
import {upperCaseFirstLetter} from '../../../../utils';
import AppsMenuIcon from '../icons/apps';
import ContactsFlowLogo from "./components/logo";
import './index.css';

function TopMenu ({sharingPageReady, removeAllExtended, extendSubMenu}) {

	const { t } = useTranslation();

	const language = useSelector( state => state.languageReducer.language);
	const profile = useSelector( state => state.profileReducer.getProfile);

	const isActiveFunc = (pageName) => {
		return window.location.search === '?page='+ pageName || window.location.pathname.includes('/' + pageName)
	};

	return (
		<ul className="top-menu">
			<li className="logo">
				<NavLink to="/" exact={true}>
					<ContactsFlowLogo/>
				</NavLink>
			</li>
			{
				sharingPageReady && <>
					<li>
						<NavLink onClick={removeAllExtended} to={'/contacts'} isActive={() => isActiveFunc('contacts')}>
							<Icon name="address-book"/>
						</NavLink>
					</li>
					{
						profile.role === "ADMINISTRATOR" && <li>
							<NavLink to="/account" onClick={extendSubMenu} isActive={() => isActiveFunc('account')} type="button">
								<Icon name="usd"/>
							</NavLink>
							<ul className="submenu">
								<li>
									<a href={`/sm/subscriptions`} target="_blank" rel="noreferrer">{upperCaseFirstLetter(t('textSubscription'))}</a>
								</li>
								<li>
									<a href={`/sm/invoices`} target="_blank" rel="noreferrer">{t('submenuInvoices')}</a>
								</li>
								<li>
									<a href={`/sm/profile`} target="_blank" rel="noreferrer">{t('submenuCompanyProfile')}</a>
								</li>
								<li>
									<a href={`/sm/payment-information`} target="_blank" rel="noreferrer">{t('submenuPaymentMethods')}</a>
								</li>
							</ul>
						</li>
					}
					{
						profile.role === "ADMINISTRATOR" && <li>
							<NavLink onClick={extendSubMenu} to={'/dashboard'} isActive={() => isActiveFunc('dashboard')}>
								<Icon name="wrench"/>
							</NavLink>
							<ul className="submenu">
								<li><NavLink onClick={removeAllExtended} to={`/review-deleted-contacts`}>{upperCaseFirstLetter(t('menuReviewDeletedContacts'))}</NavLink></li>
								<li><NavLink onClick={removeAllExtended} to={'/dashboard/users-list'}>{upperCaseFirstLetter(t("textAdminLicenses"))}</NavLink></li>
								{
									profile.domain.gsuiteDomain && <li><NavLink onClick={removeAllExtended}
												 to={'/dashboard/custom-fields-manager'}>{upperCaseFirstLetter(t("menuCustomFieldsManager"))}</NavLink>
									</li>
								}
								<li><NavLink onClick={removeAllExtended}
											 to={`/dashboard/api-key`}>{t('submenuApiKey')}</NavLink></li>
							</ul>
						</li>
					}
					<li>
						<button type="button" onClick={extendSubMenu}>
							<AppsMenuIcon />
						</button>
						<ul className="submenu">
							<li>
								<a href="https://workspace.google.com/marketplace/app/shared_contacts_for_gmail%C2%AE_share_google/411072400724"
								   target="_blank" rel="noreferrer">{upperCaseFirstLetter(t("textGmailAddOn"))}</a>
							</li>
							<li>
								<a href="https://chrome.google.com/webstore/detail/share-for-%E2%80%9Cgoogle-contact/nllecbomigehlngfclbgjeghfmfajfgp"
								   target="_blank" rel="noreferrer">{upperCaseFirstLetter(t("textChromeExtension"))}</a>
							</li>
							<li>
								<a href="https://apps.apple.com/gb/app/shared-contacts-for-gmail/id1527060811"
								   target="_blank" rel="noreferrer">{upperCaseFirstLetter(t("textiOSApp"))}</a>
							</li>
							<li>
								<a href="https://play.google.com/store/apps/details?id=com.gmailsharedcontacts&amp;hl=en&amp;gl=US"
								   target="_blank" rel="noreferrer">{upperCaseFirstLetter(t("textAndroidApp"))}</a>
							</li>
						</ul>
					</li>
					<li>
						<button onClick={extendSubMenu} type="button">
							<Icon name="question"/>
						</button>
						<ul className="submenu">
							<li>
								<NavLink onClick={removeAllExtended} to={'/support'}>{upperCaseFirstLetter(t("textHelpSupport"))}</NavLink>
							</li>
							<li>
								<a href={`https://www.getsharedcontacts.com/${language}/knowledge-base`} target="_blank"
								   rel="noreferrer">
									{upperCaseFirstLetter(t("subMenuKnowledgeBase"))}
								</a>
							</li>
						</ul>
					</li>
				</>
			}
		</ul>
	)
}

export default TopMenu;
